import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { DrawerBody, DrawerFooter, Button } from '@one-thd/sui-atomic-components';
import { RatingsAndReviewsCondensed } from '@thd-olt-component-react/ratings-and-reviews';
import { AddToContext } from '../../AddToContext';
import { SCREENS } from '../../AddToConstants';
import { useIntentProductData } from '../../hooks/useIntentProductData';

export const ProductReviews = ({
  itemId, updateList, isDisplayOnly, isIntent, handleResolveIntent
}) => {
  const { setScreen, addToType } = useContext(AddToContext);
  const { PROJECT_SELECT_GROUP, DEFAULT } = SCREENS;

  const { omsId, sku } = useIntentProductData({ itemId, isIntent });

  const handleSubmit = async () => {
    if (addToType === 'List') {
      await updateList({
        variables: {
          products: [{ itemId, quantity: 1 }]
        }
      });
      setScreen(DEFAULT);
    } else if (addToType === 'Project' && isIntent) {
      await handleResolveIntent({
        omsId,
        sku
      });
    } else {
      setScreen(PROJECT_SELECT_GROUP);
    }
  };

  return (
    <>
      <DrawerBody data-testid="test-productreviews">
        <RatingsAndReviewsCondensed itemId={itemId} />
      </DrawerBody>
      <DrawerFooter position="center">
        {!isDisplayOnly && (
          <Button
            data-testid="productReviews-AITP-button"
            variant="secondary"
            fullWidth
            onClick={handleSubmit}
            type="submit"
          >
            Add to {addToType}
          </Button>
        )}
      </DrawerFooter>
    </>
  );
};

ProductReviews.displayName = 'ProductReviews';

ProductReviews.propTypes = {
  itemId: PropTypes.string.isRequired,
  updateList: PropTypes.func,
  isDisplayOnly: PropTypes.bool,
  handleResolveIntent: PropTypes.func,
  isIntent: PropTypes.bool
};

ProductReviews.defaultProps = {
  updateList: () => {},
  isDisplayOnly: false,
  handleResolveIntent: null,
  isIntent: false
};

ProductReviews.dataModel = extend(RatingsAndReviewsCondensed, useIntentProductData);
